<template>
  <v-app>
		<v-sheet
			:height="400"
			:width="400"
			border
			rounded
			class="noAccessSheet"
		>
			<div class="westatLogoHeader">
        <img src="../assets/westat.png" alt="logo" />
    	</div>
			<img
				class="marginFifteen"
      	src="../assets/wgmm_eagle_logo.svg"
      	alt="logo"
    	/>
			<div class="marginFifteen">
				<h4 class="noAccessText">No access. Incorect role. Contact your administrator.</h4>
				<v-btn style="margin-top: 20px" block class="blue-button" @click="cancel">Back to login</v-btn>
			</div>
		</v-sheet>
  </v-app>
</template>

<script>
import router from "@/router";

export default {
  name: "noAccess",
  data() {
    return {
    };
  },
  methods: {
    cancel() {
      router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.noAccessSheet {
	margin-left: auto;
	margin-right: auto;
	margin-top: auto;
	margin-bottom: auto;
	background-color: rgb(240, 249, 254);
}

.westatLogoHeader {
  background-color: #f5f5f5;
  padding: 10px 15px;
}

.noAccessText{
	color: #15667c;
  font-size: 24px;
	margin-top: 50px;
}

.marginFifteen {
	margin: 15px
}

</style>
